<template>
  <div class="w-full md:hidden bg-white h-24 flex items-center p-4 pl-22px">
    <img
      v-if="isItWellbeinggateway"
      class="w-74"
      :src="`${s3Bucket}/images/wellbeinggateway_colour.png`" />
    <img
      v-else-if="isItSurmount"
      class="w-48"
      :src="`${s3Bucket}/Logo/grey/surmount_grey.png`" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { getAssetsS3BucketLink } from '@/lib/WhiteLabelHelpers'
import { useSessionStore } from '@/store/pinia/SessionStore'

// Composables
const sessionStore = useSessionStore()

// Data
const s3Bucket = getAssetsS3BucketLink()

// Computed properties (replacing Vuex mapGetters)
const isItWellbeinggateway = computed(() => sessionStore.getWhitelabelData.identifier === 'WELLBEING_GATEWAY' || sessionStore.getWhitelabelData.identifier === 'WBG')
const isItSurmount = computed(() => sessionStore.getWhitelabelData.identifier === 'surmount')
</script>

<style scoped></style>
